export default __webpack_public_path__ + "static/media/cp_geo_dj.71cf15bf.svg";